import React from "react";
import styles from "./styles.module.scss";

// Carregamento de página inteira (verificação de sessão, troca de conta).
const FullScreenLoader: React.FC = () => (
  <div className={styles.overlay} role="status" aria-live="polite">
    <img src="/images/logo.webp" alt="" className={styles.logo} />
    <span className={styles.spinner} aria-hidden="true" />
    <span className={styles.srOnly}>Carregando…</span>
  </div>
);

export default FullScreenLoader;
